import { cn } from "cn";
import type * as React from "react";

/**
 * A full-screen v3.2 wait (EMR launch): the mark over the canvas, a quiet
 * three-dot pulse and one line saying what is happening. `mark` is the logo
 * (e.g. <Logo size={40} wordmark={false} />).
 */
export function LoadingScreen({
  label,
  mark,
  className,
}: {
  label: string;
  mark?: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      aria-live="polite"
      className={cn(
        "flex h-screen flex-col items-center justify-center gap-5 bg-v3-canvas px-4 font-v3 text-v3-text supports-[height:100dvh]:h-dvh",
        className,
      )}
      data-testid="v3-loading-screen"
      role="status"
    >
      {mark}
      <span aria-hidden className="flex items-center gap-1.5">
        {[0, 1, 2].map((dot) => (
          <span
            key={dot}
            className="size-1.5 animate-pulse rounded-full bg-v3-text-3 motion-reduce:animate-none"
            style={{ animationDelay: `${dot * 180}ms` }}
          />
        ))}
      </span>
      <p className="text-[14px] font-medium text-v3-text-2">{label}</p>
    </div>
  );
}
